// src/features/support/components/TicketList.tsx
import type { Ticket } from './TicketRow';
import { TicketRow } from './TicketRow';

interface TicketListProps {
  tickets: Ticket[];
}

export function TicketList({ tickets }: TicketListProps) {
  if (tickets.length === 0) {
    return (
      <p className="px-5 py-6 text-center text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
        تیکتی یافت نشد.
      </p>
    );
  }

  return (
    <div className="divide-y divide-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))]">
      {tickets.map((ticket) => (
        <TicketRow key={ticket.id} ticket={ticket} />
      ))}
    </div>
  );
}
